// Start/pause video modal on open/close
export default function toggleVideoModal(videoType) {
    if (videoType == "youtube") {
        const videoModals = document.querySelectorAll(".video-modal");

        videoModals.forEach((videoModal) => {
            let iframe = videoModal.querySelector("iframe"); // Select iframe within current modal

            videoModal.addEventListener("shown.bs.modal", () => {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");

                document.querySelector(".responsive-video-container video").pause();
            });

            videoModal.addEventListener("hide.bs.modal", () => {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");

                document.querySelector(".responsive-video-container video").play();
            });
        });
    } else if (videoType == "vimeo") {
        const videoModals = document.querySelectorAll(".video-modal");

        videoModals.forEach((videoModal) => {
            let iframe = videoModal.querySelector("iframe"); // Select iframe within current modal

            videoModal.addEventListener("shown.bs.modal", () => {
                iframe.contentWindow.postMessage('{"method":"play"}', "https://player.vimeo.com");
            });

            videoModal.addEventListener("hide.bs.modal", () => {
                iframe.contentWindow.postMessage('{"method":"pause"}', "https://player.vimeo.com");
            });
        });
    }
}
